import { FC, useCallback, useEffect, useState } from 'react'
import { useNavigate } from 'react-router'
import { fetchOauthNonce } from 'services'
import styled from 'styled-components'
import { Box } from '@mrshmllw/smores-react'

import Loader from '../../../../components/Loader'
import { ErrorCode } from '../../../../Error/OpenBankingErrorPage'
import { OpenPlaidButton } from '../ConnectYourBank/OpenPlaidButton'
import { getResumeTokenFromHash, storeResumeToken } from '../ConnectYourBank/resumeToken'

import { api } from 'app/services'
import { logger, report, useQuery } from 'utils'

type PlaidProps = {
  oauthStateId: string
  quoteId: string
  paymentPlan: string
  updateMode: boolean
}

export const PlaidPostRedirectLoadingPage: FC<PlaidProps> = ({
  oauthStateId,
  quoteId,
  updateMode,
}) => {
  const query = useQuery()
  const navigate = useNavigate()

  const resumeToken = getResumeTokenFromHash()

  const [resumed, setResumed] = useState(false)
  const [oAuthNonce, setOAuthNonce] = useState(undefined as string | undefined)

  const paymentPlan = query.get('payment')

  const redirectWithErrorCode = useCallback(
    (errorCode: ErrorCode) => {
      if (paymentPlan) {
        navigate(
          `/quote/${quoteId}/connect-your-bank/error?payment=${paymentPlan}&errorCode=${errorCode}`,
        )
      } else {
        navigate(`/quote/${quoteId}/connect-your-bank/error?errorCode=${errorCode}`)
      }
    },
    [quoteId, navigate, paymentPlan],
  )

  useEffect(() => {
    if (!resumeToken) {
      logger.error('No resume token available in hash.')

      redirectWithErrorCode('resume_token_unavailable')

      return
    }

    api
      .post(`/quoting/quotes/${quoteId}/resume`, { resumeQuoteToken: resumeToken })
      .then(() => {
        storeResumeToken(resumeToken)

        setResumed(true)

        fetchOauthNonce(quoteId, setOAuthNonce, navigate)
      })
      .catch((err) => {
        report(err, 'Unable to resume')

        redirectWithErrorCode('unable_to_resume')
      })
  }, [resumeToken])

  return (
    <>
      <Loader />

      {!!quoteId && !!oauthStateId && !!oAuthNonce && resumeToken && resumed && (
        <HiddenBox>
          <OpenPlaidButton
            setIsLoading={() => {
              // Do nothing, we should display the loader until the customer gets redirected to another page
            }}
            oauthNonce={oAuthNonce}
            oauthStateId={oauthStateId}
            callToAction="Confirm"
            updateMode={updateMode}
            quoteId={quoteId}
            postOAuth
            openAutomatically
            resumeToken={resumeToken}
          />
        </HiddenBox>
      )}
    </>
  )
}

const HiddenBox = styled(Box)`
  display: none;
  visibility: hidden;
`
